import { useLang } from "@/i18n/LanguageContext";
import { motion } from "framer-motion";
import { ASSETS } from "@/lib/assets";

export default function HowItWorks() {
  const { t } = useLang();

  return (
    <section id="how" data-testid="how-it-works" className="relative scroll-mt-28 py-24 md:py-32">
      <div className="container-x">
        <div className="max-w-2xl">
          <span className="overline" data-testid="how-overline">{t.how.overline}</span>
          <h2 className="mt-4 text-4xl text-zinc-900 md:text-[52px] md:leading-[1.05]">{t.how.title}</h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {t.how.steps.map((s, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group flex flex-col"
              data-testid={`how-step-${i}`}
            >
              <div className="overflow-hidden rounded-2xl border border-zinc-200 bg-zinc-100 shadow-[0_18px_50px_-36px_rgba(81,75,186,0.45)] transition group-hover:border-[color:var(--sentinel-accent)]">
                <img
                  src={ASSETS.howItWorks[i]}
                  alt={s.t}
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover object-top transition duration-500 group-hover:scale-[1.02]"
                />
              </div>
              <div className="mt-5 flex items-baseline gap-3">
                <span className="font-mono text-xs text-[color:var(--sentinel)]">{s.n}</span>
                <h3 className="text-xl text-zinc-900">{s.t}</h3>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-zinc-600">{s.d}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
